import { render, staticRenderFns } from "./CertificationItem.vue?vue&type=template&id=991b5a8a&scoped=true"
import script from "./CertificationItem.vue?vue&type=script&lang=js"
export * from "./CertificationItem.vue?vue&type=script&lang=js"
import style0 from "./CertificationItem.vue?vue&type=style&index=0&id=991b5a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991b5a8a",
  null
  
)

export default component.exports